import type { HansAckerReport } from './types';
import { panorama360Report } from './panorama360Report';
import { valetParkingReport } from './valetParkingReport';
import { hansAckerReportKey } from './utils';

const REPORTS = { 'valet-parking': valetParkingReport, panorama360: panorama360Report };

/** Resolves the bundled Hans-Acker report for a project name, or null when the tab is unavailable. */
export const getHansAckerReport = (projectName?: string | null, mode?: string): HansAckerReport | null => {
  const key = hansAckerReportKey(projectName, mode);
  return key ? REPORTS[key] : null;
};
